import { __decorate } from 'tslib';
import { ɵɵdefineInjectable, Injectable, Input, ViewChild, Component, NgModule } from '@angular/core';
import { Subject, BehaviorSubject, Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/platform-browser';
import * as ɵngcc2 from '@angular/common';

const _c0 = ["player"];
const _c1 = ["trackSlider"];
function GsPlayerComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function GsPlayerComponent_div_4_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span", 26);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("\u00A0", ctx_r8.playerConfig.artistAlbumSeparator, "");
} }
function GsPlayerComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 23)(1, "span", 24);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, GsPlayerComponent_div_4_ng_container_3_Template, 3, 1, "ng-container", 25);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.currentFile.file.name);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.playerConfig && ctx_r2.playerConfig.artistAlbumSeparator);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.currentFile.file.artist, " ");
} }
function GsPlayerComponent__svg_path_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelement(0, "path", 27);
} }
function GsPlayerComponent__svg_path_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelement(0, "path", 28);
} }
function GsPlayerComponent_ng_template_29_ng_container_0_div_3_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const file_r11 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", file_r11.artist, " ");
} }
function GsPlayerComponent_ng_template_29_ng_container_0_div_3_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, " \u2022 ");
    ɵngcc0.ɵɵelementContainerEnd();
} }
function GsPlayerComponent_ng_template_29_ng_container_0_div_3_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const file_r11 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", file_r11.album, " ");
} }
function GsPlayerComponent_ng_template_29_ng_container_0_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 32);
    ɵngcc0.ɵɵlistener("click", function GsPlayerComponent_ng_template_29_ng_container_0_div_3_Template_div_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r19); const file_r11 = restoredCtx.$implicit; const i_r12 = restoredCtx.index; const ctx_r18 = ɵngcc0.ɵɵnextContext(3); return ctx_r18.openFile(file_r11, i_r12); });
    ɵngcc0.ɵɵelementStart(1, "span", 33);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, GsPlayerComponent_ng_template_29_ng_container_0_div_3_ng_container_3_Template, 2, 1, "ng-container", 25);
    ɵngcc0.ɵɵtemplate(4, GsPlayerComponent_ng_template_29_ng_container_0_div_3_ng_container_4_Template, 2, 0, "ng-container", 25);
    ɵngcc0.ɵɵtemplate(5, GsPlayerComponent_ng_template_29_ng_container_0_div_3_ng_container_5_Template, 2, 1, "ng-container", 25);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const file_r11 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", file_r11.name, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", file_r11.artist);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", file_r11.artist && file_r11.album);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", file_r11.album);
} }
function GsPlayerComponent_ng_template_29_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵnamespaceHTML();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 29)(2, "div", 30);
    ɵngcc0.ɵɵtemplate(3, GsPlayerComponent_ng_template_29_ng_container_0_div_3_Template, 6, 4, "div", 31);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r9.files);
} }
function GsPlayerComponent_ng_template_29_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵtemplate(0, GsPlayerComponent_ng_template_29_ng_container_0_Template, 4, 1, "ng-container", 25);
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r7.showPlayList);
} }
let GsPlayerService = class GsPlayerService {
    constructor() {
        this.stop$ = new Subject();
        this.audioObj = new Audio();
        this.audioEvents = [
            'ended',
            'error',
            'play',
            'playing',
            'pause',
            'timeupdate',
            'canplay',
            'loadedmetadata',
            'loadstart'
        ];
        this.state = {
            playing: false,
            readableCurrentTime: '',
            readableDuration: '',
            duration: undefined,
            currentTime: undefined,
            canplay: false,
            error: false,
        };
        this.stateChange = new BehaviorSubject(this.state);
    }
    getState() {
        return this.stateChange.asObservable();
    }
    streamObservable(url) {
        return new Observable(observer => {
            // Play audio
            this.audioObj.src = url;
            this.audioObj.load();
            this.audioObj.play();
            const handler = (event) => {
                this.updateStateEvents(event);
                observer.next(event);
            };
            this.addEvents(this.audioObj, this.audioEvents, handler);
            return () => {
                // Stop Playing
                this.audioObj.pause();
                this.audioObj.currentTime = 0;
                // remove event listeners
                this.removeEvents(this.audioObj, this.audioEvents, handler);
                // reset state
                this.resetState();
            };
        });
    }
    addEvents(obj, events, handler) {
        events.forEach(event => {
            obj.addEventListener(event, handler);
        });
    }
    removeEvents(obj, events, handler) {
        events.forEach(event => {
            obj.removeEventListener(event, handler);
        });
    }
    resetState() {
        this.state = {
            playing: false,
            readableCurrentTime: '',
            readableDuration: '',
            duration: undefined,
            currentTime: undefined,
            canplay: false,
            error: false
        };
    }
    updateStateEvents(event) {
        switch (event.type) {
            case 'canplay':
                this.state.duration = this.audioObj.duration;
                this.state.readableDuration = this.formatTime(this.state.duration);
                this.state.canplay = true;
                break;
            case 'playing':
                this.state.playing = true;
                break;
            case 'pause':
                this.state.playing = false;
                break;
            case 'timeupdate':
                this.state.currentTime = this.audioObj.currentTime;
                this.state.readableCurrentTime = this.formatTime(this.state.currentTime);
                break;
            case 'error':
                this.resetState();
                this.state.error = true;
                break;
        }
        this.stateChange.next(this.state);
    }
    playStream(url) {
        return this.streamObservable(url).pipe(takeUntil(this.stop$));
    }
    play() {
        this.audioObj.play();
    }
    pause() {
        this.audioObj.pause();
    }
    stop() {
        this.stop$.next();
    }
    seekTo(seconds) {
        this.audioObj.currentTime = seconds;
    }
    formatTime(time) {
        const date = new Date(time * 1000);
        const hours = date.getUTCHours().toString().padStart(2, '0');
        const minutes = date.getUTCMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');
        return `${hours}:${minutes}:${seconds}`;
    }
};
GsPlayerService.ɵfac = function GsPlayerService_Factory(t) { return new (t || GsPlayerService)(); };
GsPlayerService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: GsPlayerService, factory: function (t) { return GsPlayerService.ɵfac(t); }, providedIn: 'root' });
GsPlayerService.ngInjectableDef = ɵɵdefineInjectable({ factory: function GsPlayerService_Factory() { return new GsPlayerService(); }, token: GsPlayerService, providedIn: "root" });

let GsPlayerComponent = class GsPlayerComponent {
    constructor(sanitizer, playerService) {
        this.sanitizer = sanitizer;
        this.playerService = playerService;
        this.files = [];
        this.showPlayList = false;
    }
    ngOnInit() {
        // listen to stream state
        this.playerService.getState().subscribe(state => {
            this.state = state;
        });
        this.currentFile = {
            index: 0,
            file: this.files[0]
        };
        this.playerService.stop();
        this.playStream(this.files[0].url);
    }
    ngAfterViewInit() {
        this.setThemeColor(this.playerTheme.primary, this.playerTheme.secondary);
    }
    ngOnChanges(changes) {
        if (this.player && changes.playerTheme.currentValue.primary || changes.playerTheme.currentValue.secondary) {
            this.setThemeColor(changes.playerTheme.currentValue.primary, changes.playerTheme.currentValue.secondary);
        }
    }
    setThemeColor(primary, secondary) {
        if (this.player) {
            const player = this.player.nativeElement;
            const elementColor = [
                // .gs-player .media-title
                player.children[0],
                // .gs-player .media-text
                player.children[1].children[1].children[0],
                // .gs-player .media-text
                player.children[1].children[1].children[2]
            ];
            const elementBackground = [
                // .slidecontainer .slider
                player.children[1].children[1].children[1].children[0]
            ];
            const svgFill = [
                // svg.icon "previous"
                player.children[1].children[0].children[0].children[0],
                // svg.icon "play/pause"
                player.children[1].children[0].children[1].children[0],
                // svg.icon "next"
                player.children[1].children[0].children[2].children[0],
                // svg.icon "menu"
                player.children[1].children[2].children[0].children[0]
            ];
            // color
            elementColor.forEach(element => {
                element.style.color = primary;
            });
            // background
            elementBackground.forEach(element => {
                element.style.background = secondary;
            });
            // fill
            svgFill.forEach(svg => {
                svg.style.fill = primary;
            });
            this.sliderProps = {
                fill: primary,
                background: secondary
            };
            this.setSliderFill();
        }
    }
    setSliderFill() {
        const slider = this.trackSlider.nativeElement;
        const percentage = (100 * (slider.value - slider.min)) / (slider.max - slider.min);
        const bg = `linear-gradient(
      90deg, ${this.sliderProps.fill} ${percentage}%, ${this.sliderProps.background} ${percentage + 0.1}%
    )`;
        slider.style.background = bg;
    }
    playStream(url) {
        this.playerService.playStream(url).subscribe(events => { });
    }
    openFile(file, index) {
        this.currentFile = { index, file };
        this.playerService.stop();
        this.playStream(file.url);
        this.tooglePlayList(true);
    }
    pause() {
        this.playerService.pause();
    }
    play() {
        this.playerService.play();
    }
    playPause() {
        if (!this.state.playing) {
            this.playerService.play();
        }
        else {
            this.playerService.pause();
        }
    }
    stop() {
        this.playerService.stop();
    }
    next() {
        const index = this.currentFile.index + 1;
        const file = this.files[index];
        this.openFile(file, index);
    }
    previous() {
        const index = this.currentFile.index - 1;
        const file = this.files[index];
        this.openFile(file, index);
    }
    isFirstPlaying() {
        return this.currentFile.index === 0;
    }
    isLastPlaying() {
        return this.currentFile.index === this.files.length - 1;
    }
    onSliderChangeEnd(change) {
        this.setSliderFill();
        this.playerService.seekTo(change.srcElement.value);
    }
    tooglePlayList(isPlaying) {
        this.showPlayList = isPlaying ? false : !this.showPlayList;
    }
};
GsPlayerComponent.ɵfac = function GsPlayerComponent_Factory(t) { return new (t || GsPlayerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DomSanitizer), ɵngcc0.ɵɵdirectiveInject(GsPlayerService)); };
GsPlayerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: GsPlayerComponent, selectors: [["gs-player"]], viewQuery: function GsPlayerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 5);
        ɵngcc0.ɵɵviewQuery(_c1, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.player = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.trackSlider = _t.first);
    } }, inputs: { files: "files", playerTheme: "playerTheme", playerConfig: "playerConfig" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 31, vars: 15, consts: [[1, "'player-wrapper"], [1, "gs-player"], ["player", ""], [4, "ngTemplateOutlet"], ["class", "media-title", 4, "ngIf"], [1, "media-ui"], [1, "media-control"], [3, "click"], ["xmlns", "http://www.w3.org/2000/svg", "width", "24", "height", "24", "viewBox", "0 0 24 24", 1, "icon"], ["d", "M4 2v20h-2v-20h2zm18 0l-16 10 16 10v-20z"], [1, "play-pause-btn", 3, "click"], ["d", "M3 22v-20l18 10-18 10z", 4, "ngIf"], ["d", "M10 24h-6v-24h6v24zm10-24h-6v24h6v-24z", 4, "ngIf"], ["d", "M20 22v-20h2v20h-2zm-18 0l16-10-16-10v20z"], [1, "media-status"], [1, "media-text", "currenttime"], [1, "slidecontainer"], ["type", "range", "step", "1", 1, "slider", 3, "min", "max", "value", "input"], ["trackSlider", ""], [1, "media-text", "duration"], [1, "media-list"], ["d", "M24 6h-24v-4h24v4zm0 4h-24v4h24v-4zm0 8h-24v4h24v-4z"], ["playlist", ""], [1, "media-title"], [1, "file"], [4, "ngIf"], [1, "separator"], ["d", "M3 22v-20l18 10-18 10z"], ["d", "M10 24h-6v-24h6v24zm10-24h-6v24h6v-24z"], [1, "play-list-container"], [1, "play-list"], ["class", "file ellipsis", 3, "click", 4, "ngFor", "ngForOf"], [1, "file", "ellipsis", 3, "click"], [1, "file-title", "ellipsis"]], template: function GsPlayerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1, 2);
        ɵngcc0.ɵɵtemplate(3, GsPlayerComponent_ng_container_3_Template, 1, 0, "ng-container", 3);
        ɵngcc0.ɵɵtemplate(4, GsPlayerComponent_div_4_Template, 5, 3, "div", 4);
        ɵngcc0.ɵɵelementStart(5, "div", 5)(6, "div", 6)(7, "span", 7);
        ɵngcc0.ɵɵlistener("click", function GsPlayerComponent_Template_span_click_7_listener() { return ctx.previous(); });
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(8, "svg", 8);
        ɵngcc0.ɵɵelement(9, "path", 9);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(10, "span", 10);
        ɵngcc0.ɵɵlistener("click", function GsPlayerComponent_Template_span_click_10_listener() { return ctx.playPause(); });
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(11, "svg", 8);
        ɵngcc0.ɵɵtemplate(12, GsPlayerComponent__svg_path_12_Template, 1, 0, "path", 11);
        ɵngcc0.ɵɵtemplate(13, GsPlayerComponent__svg_path_13_Template, 1, 0, "path", 12);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(14, "span", 7);
        ɵngcc0.ɵɵlistener("click", function GsPlayerComponent_Template_span_click_14_listener() { return ctx.next(); });
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(15, "svg", 8);
        ɵngcc0.ɵɵelement(16, "path", 13);
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(17, "div", 14)(18, "span", 15);
        ɵngcc0.ɵɵtext(19);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "div", 16)(21, "input", 17, 18);
        ɵngcc0.ɵɵlistener("input", function GsPlayerComponent_Template_input_input_21_listener($event) { return ctx.onSliderChangeEnd($event); });
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(23, "span", 19);
        ɵngcc0.ɵɵtext(24);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(25, "div", 20)(26, "span", 7);
        ɵngcc0.ɵɵlistener("click", function GsPlayerComponent_Template_span_click_26_listener() { return ctx.tooglePlayList(); });
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(27, "svg", 8);
        ɵngcc0.ɵɵelement(28, "path", 21);
        ɵngcc0.ɵɵelementEnd()()()()()();
        ɵngcc0.ɵɵtemplate(29, GsPlayerComponent_ng_template_29_Template, 1, 1, "ng-template", null, 22, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r6 = ɵngcc0.ɵɵreference(30);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r6);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.currentFile);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵclassProp("disabled", ctx.isFirstPlaying());
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", !(ctx.state == null ? null : ctx.state.playing));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.state == null ? null : ctx.state.playing);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("disabled", ctx.isLastPlaying());
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1(" ", (ctx.state == null ? null : ctx.state.readableCurrentTime) || "00:00:00", " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("disabled", (ctx.state == null ? null : ctx.state.error) || ctx.currentFile.index === undefined);
        ɵngcc0.ɵɵproperty("min", 0)("max", ctx.state == null ? null : ctx.state.duration)("value", (ctx.state == null ? null : ctx.state.currentTime) || 0);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", (ctx.state == null ? null : ctx.state.readableDuration) || "00:00:00", " ");
    } }, directives: [ɵngcc2.NgTemplateOutlet, ɵngcc2.NgIf, ɵngcc2.NgForOf], styles: [".slidecontainer[_ngcontent-%COMP%]{width:100%}.slidecontainer[_ngcontent-%COMP%]   .slider[_ngcontent-%COMP%]{-webkit-appearance:none;width:100%;height:4px;background:var(--secondary,#eee);border-radius:12px;outline:0;opacity:.5;cursor:pointer;transition:opacity .2s ease-in-out}.slidecontainer[_ngcontent-%COMP%]   .slider[_ngcontent-%COMP%]:hover{opacity:1}.slidecontainer[_ngcontent-%COMP%]   .slider[_ngcontent-%COMP%]::-webkit-slider-thumb{border:none;-webkit-appearance:none;appearance:none;width:10px;height:10px;border-radius:50%;background:#777;cursor:pointer;opacity:1}.slidecontainer[_ngcontent-%COMP%]   .slider[_ngcontent-%COMP%]::-moz-range-thumb{border:none;width:10px;height:10px;border-radius:50%;background:#777;cursor:pointer;opacity:1}.gs-player[_ngcontent-%COMP%]{position:relative;padding:2rem}.gs-player[_ngcontent-%COMP%]   .media-title[_ngcontent-%COMP%]{text-align:center;letter-spacing:1px;color:var(--primary,#222);margin-bottom:1rem}.gs-player[_ngcontent-%COMP%]   .media-title[_ngcontent-%COMP%]   .file[_ngcontent-%COMP%]{font-weight:700}.gs-player[_ngcontent-%COMP%]   .media-text[_ngcontent-%COMP%]{opacity:.8;color:var(--primary,#222)}.gs-player[_ngcontent-%COMP%]   .media-ui[_ngcontent-%COMP%]{display:-ms-grid;display:grid;-ms-grid-columns:100px auto 50px;grid-template-columns:100px auto 50px;gap:2rem}.gs-player[_ngcontent-%COMP%]   .media-ui[_ngcontent-%COMP%]   .media-control[_ngcontent-%COMP%], .gs-player[_ngcontent-%COMP%]   .media-ui[_ngcontent-%COMP%]   .media-list[_ngcontent-%COMP%], .gs-player[_ngcontent-%COMP%]   .media-ui[_ngcontent-%COMP%]   .media-status[_ngcontent-%COMP%]{display:-ms-grid;display:grid}.gs-player[_ngcontent-%COMP%]   .media-ui[_ngcontent-%COMP%]   .media-control[_ngcontent-%COMP%]   span[_ngcontent-%COMP%], .gs-player[_ngcontent-%COMP%]   .media-ui[_ngcontent-%COMP%]   .media-list[_ngcontent-%COMP%]   span[_ngcontent-%COMP%], .gs-player[_ngcontent-%COMP%]   .media-ui[_ngcontent-%COMP%]   .media-status[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{-ms-grid-row-align:center;align-self:center;margin:0 auto}.gs-player[_ngcontent-%COMP%]   .media-ui[_ngcontent-%COMP%]   .media-control[_ngcontent-%COMP%]{-ms-grid-columns:(1fr)[3];grid-template-columns:repeat(3,1fr);gap:.5rem}.gs-player[_ngcontent-%COMP%]   .media-ui[_ngcontent-%COMP%]   .media-status[_ngcontent-%COMP%]{-ms-grid-columns:40px auto 40px;grid-template-columns:40px auto 40px;gap:2rem}svg.icon[_ngcontent-%COMP%]{width:20px;cursor:pointer;fill:var(--primary,#222);transition:.2s ease-in-out;opacity:.8}svg.icon[_ngcontent-%COMP%]:hover{opacity:1}.disabled[_ngcontent-%COMP%]{opacity:.3;cursor:default;pointer-events:none}.ellipsis[_ngcontent-%COMP%]{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.play-list-container[_ngcontent-%COMP%]{border-radius:4px;background:var(--secondary,#eee);width:220px;position:absolute;top:16px;z-index:10000;right:90px;box-shadow:0 14px 28px rgba(0,0,0,.15),0 10px 10px rgba(0,0,0,.12)}.play-list-container[_ngcontent-%COMP%]   .play-list[_ngcontent-%COMP%]{max-height:130px;overflow-y:auto}.play-list-container[_ngcontent-%COMP%]   .play-list[_ngcontent-%COMP%]   .file[_ngcontent-%COMP%]{cursor:pointer;padding:.5rem;font-size:.7rem;background:rgba(0,0,0,0);transition:.2s ease-in-out}.play-list-container[_ngcontent-%COMP%]   .play-list[_ngcontent-%COMP%]   .file[_ngcontent-%COMP%]   .file-title[_ngcontent-%COMP%]{display:block;font-size:.9rem;font-weight:700}.play-list-container[_ngcontent-%COMP%]   .play-list[_ngcontent-%COMP%]   .file[_ngcontent-%COMP%]:hover{background:rgba(0,0,0,.1)}@media screen and (max-width:768px){.gs-player[_ngcontent-%COMP%]{padding:1rem}.gs-player[_ngcontent-%COMP%]   .media-title[_ngcontent-%COMP%]{text-align:left;font-size:.7rem}.gs-player[_ngcontent-%COMP%]   .media-title[_ngcontent-%COMP%]   .file[_ngcontent-%COMP%]{display:block;font-size:1.1rem;margin-bottom:4px}.gs-player[_ngcontent-%COMP%]   .media-text[_ngcontent-%COMP%]{color:var(--secondary,#eee)}.gs-player[_ngcontent-%COMP%]   .media-ui[_ngcontent-%COMP%]{-ms-grid-columns:auto;grid-template-columns:auto;gap:1rem}.gs-player[_ngcontent-%COMP%]   .media-ui[_ngcontent-%COMP%]   .media-control[_ngcontent-%COMP%]{-ms-grid-row:2;grid-row:2}.gs-player[_ngcontent-%COMP%]   .media-ui[_ngcontent-%COMP%]   .media-status[_ngcontent-%COMP%]{-ms-grid-columns:-webkit-min-content auto -webkit-min-content;-ms-grid-columns:min-content auto min-content;grid-template-columns:-webkit-min-content auto -webkit-min-content;grid-template-columns:min-content auto min-content;-ms-grid-rows:-webkit-min-content -webkit-min-content;-ms-grid-rows:min-content min-content;grid-template-rows:-webkit-min-content -webkit-min-content;grid-template-rows:min-content min-content;-ms-grid-row:1;grid-row:1;gap:3px}.gs-player[_ngcontent-%COMP%]   .media-ui[_ngcontent-%COMP%]   .media-status[_ngcontent-%COMP%]   .media-text.currenttime[_ngcontent-%COMP%], .gs-player[_ngcontent-%COMP%]   .media-ui[_ngcontent-%COMP%]   .media-status[_ngcontent-%COMP%]   .media-text.duration[_ngcontent-%COMP%]{font-size:.7rem}.gs-player[_ngcontent-%COMP%]   .media-ui[_ngcontent-%COMP%]   .media-status[_ngcontent-%COMP%]   .currenttime[_ngcontent-%COMP%]{-ms-grid-row:2;grid-row:2;-ms-grid-column:1;grid-column:1}.gs-player[_ngcontent-%COMP%]   .media-ui[_ngcontent-%COMP%]   .media-status[_ngcontent-%COMP%]   .slidecontainer[_ngcontent-%COMP%]{-ms-grid-row:1;grid-row:1;-ms-grid-column:1;-ms-grid-column-span:3;grid-column:1/4}.gs-player[_ngcontent-%COMP%]   .media-ui[_ngcontent-%COMP%]   .media-status[_ngcontent-%COMP%]   .duration[_ngcontent-%COMP%]{-ms-grid-row:2;grid-row:2;-ms-grid-column:3;grid-column:3}.gs-player[_ngcontent-%COMP%]   .media-ui[_ngcontent-%COMP%]   .media-list[_ngcontent-%COMP%]{display:inline-block;position:absolute;top:1.4rem;right:1rem}.play-list-container[_ngcontent-%COMP%]{right:51px}.separator[_ngcontent-%COMP%]{display:none}}"] });
GsPlayerComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: GsPlayerService }
];
__decorate([
    Input()
], GsPlayerComponent.prototype, "files", void 0);
__decorate([
    Input()
], GsPlayerComponent.prototype, "playerTheme", void 0);
__decorate([
    Input()
], GsPlayerComponent.prototype, "playerConfig", void 0);
__decorate([
    ViewChild('player', { static: false })
], GsPlayerComponent.prototype, "player", void 0);
__decorate([
    ViewChild('trackSlider', { static: false })
], GsPlayerComponent.prototype, "trackSlider", void 0);

// https://auth0.com/blog/building-an-audio-player-app-with-angular-and-rxjs/
let GsPlayerModule = class GsPlayerModule {
};
GsPlayerModule.ɵfac = function GsPlayerModule_Factory(t) { return new (t || GsPlayerModule)(); };
GsPlayerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: GsPlayerModule });
GsPlayerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GsPlayerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GsPlayerComponent, [{
        type: Component,
        args: [{
                selector: 'gs-player',
                template: "<!-- main player -->\r\n<div class=\"'player-wrapper\">\r\n  <div class=\"gs-player\" #player>\r\n    <ng-container *ngTemplateOutlet=\"playlist\"></ng-container>\r\n\r\n    <div class=\"media-title\" *ngIf=\"currentFile\">\r\n      <span class=\"file\">{{ currentFile.file.name }}</span>\r\n      <ng-container *ngIf=\"playerConfig && playerConfig.artistAlbumSeparator\">\r\n        <span class=\"separator\">&nbsp;{{ playerConfig.artistAlbumSeparator }}</span>\r\n      </ng-container>\r\n      {{ currentFile.file.artist }}\r\n    </div>\r\n\r\n    <div class=\"media-ui\">\r\n      <!-- previous, play, next -->\r\n      <div class=\"media-control\">\r\n        <!-- previous button -->\r\n        <span [class.disabled]=\"isFirstPlaying()\" (click)=\"previous()\">\r\n          <svg class=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\r\n            <path d=\"M4 2v20h-2v-20h2zm18 0l-16 10 16 10v-20z\" /></svg>\r\n        </span>\r\n        <!-- play/pause button -->\r\n        <span class=\"play-pause-btn\" (click)=\"playPause()\">\r\n          <svg class=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\r\n            <path *ngIf=\"!state?.playing\" d=\"M3 22v-20l18 10-18 10z\" />\r\n            <path *ngIf=\"state?.playing\" d=\"M10 24h-6v-24h6v24zm10-24h-6v24h6v-24z\" />\r\n          </svg>\r\n        </span>\r\n        <!-- next button -->\r\n        <span [class.disabled]=\"isLastPlaying()\" (click)=\"next()\">\r\n          <svg class=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\r\n            <path d=\"M20 22v-20h2v20h-2zm-18 0l16-10-16-10v20z\" /></svg>\r\n        </span>\r\n      </div>\r\n\r\n      <!-- track time -->\r\n      <div class=\"media-status\">\r\n        <!-- Track time -->\r\n        <span class=\"media-text currenttime\">\r\n          {{ state?.readableCurrentTime || '00:00:00' }}\r\n        </span>\r\n        <!-- Track progress -->\r\n        <div class=\"slidecontainer\">\r\n          <input #trackSlider class=\"slider\" type=\"range\"\r\n            step=\"1\"\r\n            [min]=\"0\"\r\n            [max]=\"state?.duration\"\r\n            [value]=\"state?.currentTime || 0\"\r\n            [class.disabled]=\"state?.error || currentFile.index === undefined\"\r\n            (input)=\"onSliderChangeEnd($event)\">\r\n        </div>\r\n        <!-- Track duration -->\r\n        <span class=\"media-text duration\">\r\n          {{ state?.readableDuration || '00:00:00' }}\r\n        </span>\r\n      </div>\r\n\r\n      <!-- other options -->\r\n      <div class=\"media-list\">\r\n        <!-- playlist button -->\r\n        <span (click)=\"tooglePlayList()\">\r\n          <svg class=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\r\n            <path d=\"M24 6h-24v-4h24v4zm0 4h-24v4h24v-4zm0 8h-24v4h24v-4z\" /></svg>\r\n        </span>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<!-- floating play list -->\r\n<ng-template #playlist>\r\n  <ng-container *ngIf=\"showPlayList\">\r\n    <div class=\"play-list-container\">\r\n      <div class=\"play-list\">\r\n        <div class=\"file ellipsis\" *ngFor=\"let file of files; let i = index\" (click)=\"openFile(file, i)\">\r\n          <span class=\"file-title ellipsis\">\r\n            {{ file.name }}\r\n          </span>\r\n          <ng-container *ngIf=\"file.artist\">\r\n            {{ file.artist }}\r\n          </ng-container>\r\n          <ng-container *ngIf=\"file.artist && file.album\">\r\n            &#8226;\r\n          </ng-container>\r\n          <ng-container *ngIf=\"file.album\">\r\n            {{ file.album }} \r\n          </ng-container>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n</ng-template>",
                styles: [".slidecontainer{width:100%}.slidecontainer .slider{-webkit-appearance:none;width:100%;height:4px;background:var(--secondary,#eee);border-radius:12px;outline:0;opacity:.5;cursor:pointer;transition:opacity .2s ease-in-out}.slidecontainer .slider:hover{opacity:1}.slidecontainer .slider::-webkit-slider-thumb{border:none;-webkit-appearance:none;appearance:none;width:10px;height:10px;border-radius:50%;background:#777;cursor:pointer;opacity:1}.slidecontainer .slider::-moz-range-thumb{border:none;width:10px;height:10px;border-radius:50%;background:#777;cursor:pointer;opacity:1}.gs-player{position:relative;padding:2rem}.gs-player .media-title{text-align:center;letter-spacing:1px;color:var(--primary,#222);margin-bottom:1rem}.gs-player .media-title .file{font-weight:700}.gs-player .media-text{opacity:.8;color:var(--primary,#222)}.gs-player .media-ui{display:-ms-grid;display:grid;-ms-grid-columns:100px auto 50px;grid-template-columns:100px auto 50px;gap:2rem}.gs-player .media-ui .media-control,.gs-player .media-ui .media-list,.gs-player .media-ui .media-status{display:-ms-grid;display:grid}.gs-player .media-ui .media-control span,.gs-player .media-ui .media-list span,.gs-player .media-ui .media-status span{-ms-grid-row-align:center;align-self:center;margin:0 auto}.gs-player .media-ui .media-control{-ms-grid-columns:(1fr)[3];grid-template-columns:repeat(3,1fr);gap:.5rem}.gs-player .media-ui .media-status{-ms-grid-columns:40px auto 40px;grid-template-columns:40px auto 40px;gap:2rem}svg.icon{width:20px;cursor:pointer;fill:var(--primary,#222);transition:.2s ease-in-out;opacity:.8}svg.icon:hover{opacity:1}.disabled{opacity:.3;cursor:default;pointer-events:none}.ellipsis{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.play-list-container{border-radius:4px;background:var(--secondary,#eee);width:220px;position:absolute;top:16px;z-index:10000;right:90px;box-shadow:0 14px 28px rgba(0,0,0,.15),0 10px 10px rgba(0,0,0,.12)}.play-list-container .play-list{max-height:130px;overflow-y:auto}.play-list-container .play-list .file{cursor:pointer;padding:.5rem;font-size:.7rem;background:rgba(0,0,0,0);transition:.2s ease-in-out}.play-list-container .play-list .file .file-title{display:block;font-size:.9rem;font-weight:700}.play-list-container .play-list .file:hover{background:rgba(0,0,0,.1)}@media screen and (max-width:768px){.gs-player{padding:1rem}.gs-player .media-title{text-align:left;font-size:.7rem}.gs-player .media-title .file{display:block;font-size:1.1rem;margin-bottom:4px}.gs-player .media-text{color:var(--secondary,#eee)}.gs-player .media-ui{-ms-grid-columns:auto;grid-template-columns:auto;gap:1rem}.gs-player .media-ui .media-control{-ms-grid-row:2;grid-row:2}.gs-player .media-ui .media-status{-ms-grid-columns:-webkit-min-content auto -webkit-min-content;-ms-grid-columns:min-content auto min-content;grid-template-columns:-webkit-min-content auto -webkit-min-content;grid-template-columns:min-content auto min-content;-ms-grid-rows:-webkit-min-content -webkit-min-content;-ms-grid-rows:min-content min-content;grid-template-rows:-webkit-min-content -webkit-min-content;grid-template-rows:min-content min-content;-ms-grid-row:1;grid-row:1;gap:3px}.gs-player .media-ui .media-status .media-text.currenttime,.gs-player .media-ui .media-status .media-text.duration{font-size:.7rem}.gs-player .media-ui .media-status .currenttime{-ms-grid-row:2;grid-row:2;-ms-grid-column:1;grid-column:1}.gs-player .media-ui .media-status .slidecontainer{-ms-grid-row:1;grid-row:1;-ms-grid-column:1;-ms-grid-column-span:3;grid-column:1/4}.gs-player .media-ui .media-status .duration{-ms-grid-row:2;grid-row:2;-ms-grid-column:3;grid-column:3}.gs-player .media-ui .media-list{display:inline-block;position:absolute;top:1.4rem;right:1rem}.play-list-container{right:51px}.separator{display:none}}"]
            }]
    }], function () { return [{ type: ɵngcc1.DomSanitizer }, { type: GsPlayerService }]; }, { files: [{
            type: Input
        }], playerTheme: [{
            type: Input
        }], playerConfig: [{
            type: Input
        }], player: [{
            type: ViewChild,
            args: ['player', { static: false }]
        }], trackSlider: [{
            type: ViewChild,
            args: ['trackSlider', { static: false }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GsPlayerModule, [{
        type: NgModule,
        args: [{
                declarations: [GsPlayerComponent],
                imports: [
                    CommonModule
                ],
                exports: [
                    GsPlayerComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(GsPlayerModule, { declarations: function () { return [GsPlayerComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [GsPlayerComponent]; } }); })();

const PlayerThemeLight = {
    primary: '#d3d3d3',
    secondary: '#888888'
};
const PlayerThemeDark = {
    primary: '#2c2c2c',
    secondary: '#777777'
};

/*
 * Public API Surface of gs-player
 */

/**
 * Generated bundle index. Do not edit.
 */

export { GsPlayerComponent, GsPlayerModule, GsPlayerService, PlayerThemeDark, PlayerThemeLight };

